const PERSONAL_SETTINGS = [
  '/settings/profile',
  '/settings/preferences',
  '/settings/notifications',
  '/settings/appearance',
  '/settings/security',
  // Legacy redirects still resolve briefly
  '/administration/profile',
  '/administration/preferences',
  '/administration/notifications',
];

export function roleChangedMessage(role: string): string {
  return `Your role changed to ${role}. Some actions are no longer available.`;
}

export function routeStillAllowed(path: string, role: string): boolean {
  const personal = PERSONAL_SETTINGS.some((item) => path === item || path.startsWith(`${item}/`));
  const adminOnly =
    path === '/billing' ||
    path === '/org-dashboard' ||
    path === '/scenarios' ||
    path === '/admin-home' ||
    (path.startsWith('/administration') && !personal);
  if (adminOnly && role !== 'ADMIN') return false;
  return true;
}
